import { prepareMoviesData } from '../../utils/prepareMoviesData';
import { getMoviesJsonForEnUs } from '../../utils/getMoviesJsonForEnUs';
import spanishMoviesJSON from './spanishMexico.data.json';
import amoresPerrosImageUrl from './assets/amores-perros-2000.jpg';
import amoresPerrosPreviewUrl from './assets/amores-perros-2000-preview.png';
import elLaberintoDelFaunoImageUrl from './assets/el-laberinto-del-fauno-2006.jpg';
import temporadaDePatosImageUrl from './assets/temporada-de-patos-2004.jpg';
import comoAguaParaChocolateImageUrl from './assets/como-agua-para-chocolate-1992.jpg';
import comoAguaParaChocolatePreviewUrl from './assets/como-agua-para-chocolate-1992-preview.png';
import yTuMamaTambienImageUrl from './assets/y-tu-mama-tambien-2018.jpg';
import biutifulImageUrl from './assets/biutiful-2010.jpg';
import noSeAceptanDevolucionesImageUrl from './assets/no-se-aceptan-devoluciones-2013.jpg';
import romaImageUrl from './assets/roma-2018.jpg';
import nosotrosLosNoblesImageUrl from './assets/nosotros-los-nobles-2013.jpg';
import cronosImageUrl from './assets/cronos-1993.jpg';
import matandoCabosImageUrl from './assets/matando-cabos-2004.jpg';
import laMismaLunaImageUrl from './assets/la-misma-luna-2007.jpg';
import elInfiernoImageUrl from './assets/el-infierno-2010.jpg';
import guerosImageUrl from './assets/gueros-2014.jpg';
import missBalaImageUrl from './assets/miss-bala-2011.jpg';

const images = {
  posters: {
    'amores-perros-2000': amoresPerrosImageUrl,
    'el-laberinto-del-fauno-2006': elLaberintoDelFaunoImageUrl,
    'temporada-de-patos-2004': temporadaDePatosImageUrl,
    'como-agua-para-chocolate-1992': comoAguaParaChocolateImageUrl,
    'y-tu-mama-tambien-2018': yTuMamaTambienImageUrl,
    'biutiful-2010': biutifulImageUrl,
    'no-se-aceptan-devoluciones-2013': noSeAceptanDevolucionesImageUrl,
    'roma-2018': romaImageUrl,
    'nosotros-los-nobles-2013': nosotrosLosNoblesImageUrl,
    'cronos-1993': cronosImageUrl,
    'matando-cabos-2004': matandoCabosImageUrl,
    'la-misma-luna-2007': laMismaLunaImageUrl,
    'el-infierno-2010': elInfiernoImageUrl,
    'gueros-2014': guerosImageUrl,
    'miss-bala-2011': missBalaImageUrl,
  },
  previews: {
    'amores-perros-2000': amoresPerrosPreviewUrl,
    'como-agua-para-chocolate-1992': comoAguaParaChocolatePreviewUrl,
  },
};

export const spanishMexicoMovies = prepareMoviesData(spanishMoviesJSON, images);

export const spanishMexicoMoviesForEnUs = prepareMoviesData(
  getMoviesJsonForEnUs(spanishMoviesJSON),
  images,
);
